import Vue from 'vue'
import Router from 'vue-router'
import MainOrder from '@/views/MainOrder'
import Customer from '@/views/Customer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainOrder',
      component: MainOrder,
    },
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js